import { useCallback, useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { observer } from "mobx-react-lite";
import { FormProvider, useForm } from "react-hook-form";
import { z } from "zod";
import { Button, Checkbox, Input, Modal, TextArea } from "@synthesis/shared-ui";

import { AdminModalBody, AdminModalFooter } from "../../../components/admin-console/admin-modal";
import { usePageStore } from "../constructor-services-page.lib";

const newServiceSchema = z.object({
  title: z.string().trim().min(1, "Укажите наименование услуги"),
  code: z.string().trim().min(1, "Укажите код услуги"),
  description: z.string().trim().optional(),
  serviceCode: z.string().trim().optional(),
});

type NewServiceFormValues = z.infer<typeof newServiceSchema>;

const NEW_SERVICE_DEFAULTS: NewServiceFormValues = { title: "", code: "", description: "", serviceCode: "" };

/** Модалка «Новая услуга» (макет «Услуги - Добавление новой услуги»). Открывается через стор. Бэка нет — создание пока только закрывает окно. */
export const NewServiceModal = observer(() => {
  const store = usePageStore()!;
  const isOpen = store.popupAction?.type === "add-service";
  const methods = useForm<NewServiceFormValues>({
    resolver: zodResolver(newServiceSchema),
    mode: "onChange",
    defaultValues: NEW_SERVICE_DEFAULTS,
  });
  const [isActive, setIsActive] = useState(true);

  const handleClose = useCallback(() => {
    methods.reset(NEW_SERVICE_DEFAULTS);
    setIsActive(true);
    store.setPopupAction(null);
  }, [methods, store]);

  return (
    <Modal.Root isOpen={isOpen} setIsOpen={(open) => (open ? null : handleClose())}>
      <Modal.Content className="w-[43.5rem] max-w-[90vw]">
        <Modal.Title>Новая услуга</Modal.Title>
        <FormProvider {...methods}>
          <AdminModalBody>
            <h4 className="heading-h4 text-type-common">Новая услуга</h4>

            <div className="grid grid-cols-2 gap-4">
              <Input name="title" label="Наименование услуги" placeholder="Наименование услуги" />
              <Input name="code" label="Код услуги" required placeholder="Введите код" />
            </div>

            <TextArea name="description" label="Описание" placeholder="Какую функцию выполняет услуга" />

            <TextArea name="serviceCode" label="Служебный код" placeholder="Введите форму служебного кода" />

            <Checkbox
              checked={isActive}
              onChange={(checked) => setIsActive(checked === true)}
              label="Услуга активна (Доступность заявителям на портале)"
            />
          </AdminModalBody>

          <AdminModalFooter>
            {/* TODO(FRONT-1390): сохранение услуги — после появления бэкенда. */}
            <Button theme="primary" size="lg" onClick={methods.handleSubmit(handleClose)}>
              Добавить
            </Button>
            <Button theme="secondary" size="lg" onClick={handleClose}>
              Отмена
            </Button>
          </AdminModalFooter>
        </FormProvider>
      </Modal.Content>
    </Modal.Root>
  );
});
